<template>
  <div class="swiper-card card-profile">
    <div class="corner-radius-blur"></div>
    <div class="content-stack">
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6.25V13.2812C0 14.5801 1.04492 15.625 2.34375 15.625C3.64258 15.625 4.6875 14.5801 4.6875 13.2812V6.25C4.6875 5.39062 5.39062 4.6875 6.25 4.6875H13.2812C14.5801 4.6875 15.625 3.64258 15.625 2.34375C15.625 1.04492 14.5801 0 13.2812 0H6.25C2.80273 0 0 2.80273 0 6.25ZM34.375 2.34375C34.375 3.64258 35.4199 4.6875 36.7188 4.6875H43.75C44.6094 4.6875 45.3125 5.39062 45.3125 6.25V13.2812C45.3125 14.5801 46.3574 15.625 47.6562 15.625C48.9551 15.625 50 14.5801 50 13.2812V6.25C50 2.80273 47.1973 0 43.75 0H36.7188C35.4199 0 34.375 1.04492 34.375 2.34375ZM2.34375 34.375C1.04492 34.375 0 35.4199 0 36.7188V43.75C0 47.1973 2.80273 50 6.25 50H13.2812C14.5801 50 15.625 48.9551 15.625 47.6562C15.625 46.3574 14.5801 45.3125 13.2812 45.3125H6.25C5.39062 45.3125 4.6875 44.6094 4.6875 43.75V36.7188C4.6875 35.4199 3.64258 34.375 2.34375 34.375ZM47.6562 34.375C46.3574 34.375 45.3125 35.4199 45.3125 36.7188V43.75C45.3125 44.6094 44.6094 45.3125 43.75 45.3125H36.7188C35.4199 45.3125 34.375 46.3574 34.375 47.6562C34.375 48.9551 35.4199 50 36.7188 50H43.75C47.1973 50 50 47.1973 50 43.75V36.7188C50 35.4199 48.9551 34.375 47.6562 34.375ZM25 20.3125C23.2715 20.3125 21.875 18.916 21.875 17.1875C21.875 15.459 23.2715 14.0625 25 14.0625C26.7285 14.0625 28.125 15.459 28.125 17.1875C28.125 18.916 26.7285 20.3125 25 20.3125ZM17.1875 17.1875C17.1875 21.5039 20.6836 25 25 25C29.3164 25 32.8125 21.5039 32.8125 17.1875C32.8125 12.8711 29.3164 9.375 25 9.375C20.6836 9.375 17.1875 12.8711 17.1875 17.1875ZM21.875 28.125C16.6992 28.125 12.5 32.3242 12.5 37.5V38.2812C12.5 39.5801 13.5449 40.625 14.8438 40.625C16.1426 40.625 17.1875 39.5801 17.1875 38.2812V37.5C17.1875 34.9121 19.2871 32.8125 21.875 32.8125H28.125C30.7129 32.8125 32.8125 34.9121 32.8125 37.5V38.2812C32.8125 39.5801 33.8574 40.625 35.1562 40.625C36.4551 40.625 37.5 39.5801 37.5 38.2812V37.5C37.5 32.3242 33.3008 28.125 28.125 28.125H21.875Z" fill="#FFDE00"/>
      </svg>
      <h3>Upload a profile image</h3>
      <p>Make it personal—add your photo to let others know it's you.</p>
    </div>

    <form class="profile-form" id="profile-picture-form" v-if="getAccount">
      <div class="image">
        <img id="localProfileImage" :src="getAccount.details.profilePicture" alt="" />
      </div>
      <button v-if="platform === 'android'" class="profile-upload-android" @click.prevent="requestAndroidProfileImage()">Choose an image</button>
      <div v-else class="profile-upload upload">
        <label for="profile-picture" class="button">Choose an image</label>
        <input type="file" id="profile-picture" v-on:change="updateProfileImage()" name="profilePicture" accept="image/*" />
      </div>
    </form>
  </div>
</template>

<script>
  import API from "app/axios.js";

  export default {
    data() {
      return {
        
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },


    async mounted () {
      await API.getAccount(localStorage.getItem('token'));
      this.$emit('swiperUpdate')
      this.$emit('enableNextAction');

      this.EventBus.$on('profile:image', (image) => {
        this.handleAndroidImage(image);
      })
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      platform() {
        return this.$store.getters.hasAppPlatform;
      }
    },

    methods: {
      requestAndroidProfileImage() {
        try {
          if (typeof Android !== 'undefined') {
            // eslint-disable-next-line
            Android['profileImageCallback']();
          }
        } catch (err) {
          // console.log('Android: ', err);
        }
      },

      handleAndroidImage(image) {
        this.throwResponseError = false;
        API.post(`/account/profilepicture`, {
          base64: image
        }).then((response) => {
          this.$store.commit('updateAccount', response.data);
          window.setTimeout(() => {
            this.$emit('next');
          }, 600);
        }).catch(() => {
          // console.log('Error', error)
        });
      },

      updateProfileImage() {
        var img = document.getElementById("localProfileImage");
        var input = document.getElementById("profile-picture");

        if (input.files && input.files[0]) {
          img.src = window.URL.createObjectURL(input.files[0])
        }

        this.submitProfilePictureForm();
      },

      submitProfilePictureForm() {
        this.throwResponseError = false;
        API.postForm(`/account/profilepicture`, document.getElementById('profile-picture-form')).then((response) => {
          this.$store.commit('updateAccount', response.data);
          window.setTimeout(() => {
            this.$emit('next');
          }, 600);
        }).catch(() => {
          // console.log('Error', error)
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-profile {
    align-items: center;
    text-align: center;

    .content-stack {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1rem;
      height: 100%;
      z-index: 10;
      max-width: 500px;
      margin: 0 auto 0 auto;

      svg {
        margin-bottom: 1rem;
        
        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }
      }

      h3 {
        font-family: 'Brawler';
        font-weight: normal;
        font-size: 38px;
        line-height: 110%;
        text-wrap: balance;

        .callout {
          color: $yellow-tone-4;

          .darkmode & {
            color: $yellow-tone-3;
          }
        }

        .desktop & {
          font-size: 50px;
        }
      }

      p {
        font-size: 20px;
        line-height: 150%;
        text-wrap: balance;

        .desktop & {
          max-width: 400px;
        }
      }
    }

    .profile-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 2rem;
      z-index: 10;

      .image {
        width: 11rem;
        height: 11rem;
        padding: 1rem;
        border-radius: 500px;
        border: 7px solid rgba($neutral-100, 0.07);
        overflow: hidden;
        margin: auto;

        .darkmode & {
          border-color: rgba($neutral-600, 0.1);
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 500px;
        }
      }

      .profile-upload-android {
        margin-top: 1.5rem;
      }

      .profile-upload {
        label {
          margin-top: 1.5rem;
        }

        input {
          display: none;
        }
      }
    }
  }
</style>